import React from 'react';
import { Section } from './ui/Section';
import { Leaf, Droplet, Zap, Shield, Heart, Activity } from 'lucide-react';
const ingredients = [{
  name: 'Boron',
  description: 'A vital mineral that supports healthy testosterone levels and bone density. Essential for optimal prostate function.',
  icon: <Shield className="w-8 h-8 text-[#4CAF50]" data-id="element-65" />,
  color: 'bg-blue-50'
}, {
  name: 'Tongkat Ali',
  description: 'Renowned for boosting male vitality, libido, and physical performance. Helps reduce stress and improve mood.',
  icon: <Zap className="w-8 h-8 text-[#FFC107]" data-id="element-66" />,
  color: 'bg-yellow-50'
}, {
  name: 'Ashwagandha',
  description: 'An ancient adaptogen that helps the body manage stress. Supports healthy sleep patterns and energy levels.',
  icon: <Leaf className="w-8 h-8 text-[#4CAF50]" data-id="element-67" />,
  color: 'bg-green-50'
}, {
  name: 'Fenugreek',
  description: 'Supports healthy blood sugar levels and testosterone production. Known to enhance physical strength.',
  icon: <Activity className="w-8 h-8 text-red-500" data-id="element-68" />,
  color: 'bg-red-50'
}, {
  name: 'Panax Ginseng',
  description: 'Promotes energy, stamina, and cognitive function. Supports healthy blood flow and immune response.',
  icon: <Heart className="w-8 h-8 text-rose-500" data-id="element-69" />,
  color: 'bg-rose-50'
}, {
  name: 'Maca Root',
  description: 'A superfood from the Andes that boosts libido, endurance, and mood. Rich in essential vitamins and minerals.',
  icon: <Droplet className="w-8 h-8 text-blue-500" data-id="element-70" />,
  color: 'bg-indigo-50'
}, {
  name: 'Artichoke Extract',
  description: 'Rich in antioxidants, it supports liver health and digestion. Helps maintain healthy cholesterol levels.',
  icon: <Leaf className="w-8 h-8 text-emerald-600" data-id="element-71" />,
  color: 'bg-emerald-50'
}, {
  name: 'Nettle Root',
  description: 'Traditionally used to support urinary tract health and prostate function. Helps maintain healthy inflammation levels.',
  icon: <Shield className="w-8 h-8 text-teal-600" data-id="element-72" />,
  color: 'bg-teal-50'
}];
export function IngredientsSection() {
  return <Section background="white" className="relative" data-id="element-73">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-74">
        <h2 className="text-3xl md:text-5xl font-bold text-[#0B1C3E] mb-6" data-id="element-75">
          Inside Every Potent Scoop of{' '}
          <span className="text-[#00adee]" data-id="element-76">ProstaVive</span> You'll Find...
        </h2>
        <p className="text-lg text-gray-600" data-id="element-77">
          Our unique formula combines nature's most powerful ingredients to
          create a synergistic effect that supports your prostate health from
          every angle.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-78">
        {ingredients.map((item, index) => <div key={index} className={`group p-8 rounded-2xl ${item.color} border border-transparent hover:border-gray-200 hover:shadow-xl transition-all duration-300`} data-id="element-79">
            <div className="mb-6 bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-80">
              {item.icon}
            </div>
            <h3 className="text-xl font-bold text-[#0B1C3E] mb-3" data-id="element-81">
              {item.name}
            </h3>
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-82">
              {item.description}
            </p>
          </div>)}
      </div>
    </Section>;
}